import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { ApolloProvider } from '@apollo/client';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { store } from './store';
import { AppRouter } from './router';
import { initClient } from './core/apollo/client';
import { AppVersionMiddleware } from './core/network/app-version-middleware';
import config from './core/config/config';
import { Theme } from './theme/theme';

AppVersionMiddleware.setVersion(config.appVersion);

const client = initClient();

const theme = createTheme({
  palette: {
    primary: { main: Theme.PRIMARY_COLOR },
    secondary: { main: Theme.SECONDARY_COLOR },
    text: { primary: Theme.SECONDARY_TEXT_COLOR },
    background: { default: Theme.BG_COLOR },
  },
});

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element not found');

createRoot(rootEl).render(
  <StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <ApolloProvider client={client}>
        <Provider store={store}>
          <AppRouter />
        </Provider>
      </ApolloProvider>
    </ThemeProvider>
  </StrictMode>,
);
